import { isNullOrUndefined } from '@as-react/common-utils';
import { all, call, delay, fork, getContext, put, select, spawn, takeLatest } from 'redux-saga/effects';
import { MAX_COMPARE_PRODUCTS } from '../../../components/compare-popup/ComparePopup';
import { DELAY } from '../../../constants/GeneralConstants';
import { PRODUCT_COMPARE_LIST } from '../../../constants/StorageKeysConstants';
import { ProductActionTypes, ProductComparisonActionTypes, ProductRecentlyViewedActionTypes, ProductGroupFredhopperTypes, PartialSearchActionTypes, ProductGroupActionTypes, MonetateActionTypes, WishListActionTypes, CompareActionTypes, ListerActionTypes, } from '../../../enums/ActionEnums';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
import compareActions from '../actions/CompareActions.creators';
import { getCompareState } from '../selectors/CompareSelectors';
const COMPARE_STATE_LIFETIME = 86400000; // 24h
function* loadCompareDataFromLocalStorageSaga() {
    yield takeLatest(ProductRecentlyViewedActionTypes.FETCH, loadCompareDataFromLocalStorage);
    yield takeLatest(ListerActionTypes.LISTER_INIT, loadCompareDataFromLocalStorage);
    yield takeLatest(ProductActionTypes.INIT, loadCompareDataFromLocalStorage);
    yield takeLatest(ProductComparisonActionTypes.INIT, loadCompareDataFromLocalStorage);
    yield takeLatest(ProductGroupFredhopperTypes.INIT, loadCompareDataFromLocalStorage);
    yield takeLatest(ProductGroupActionTypes.INIT, loadCompareDataFromLocalStorage);
    yield takeLatest(PartialSearchActionTypes.INIT, loadCompareDataFromLocalStorage);
    yield takeLatest(WishListActionTypes.LISTER_SET_PRODUCTS, loadCompareDataFromLocalStorage);
    yield takeLatest(MonetateActionTypes.SET_PRODUCTS, loadCompareDataFromLocalStorage);
}
function* updateCompareSaga() {
    yield takeLatest(CompareActionTypes.COMPARE_UPDATE, updateCompare);
}
export function* showAndHideComparePopup() {
    yield put(compareActions.createPopupOpenAction());
    yield delay(DELAY.DELAY_3000);
    yield put(compareActions.createPopupCloseAction());
}
export function* showCompareLimitReachedError() {
    const compareState = yield select(getCompareState);
    yield put(compareActions.createToggleLimitReachedAction(true));
    yield delay(DELAY.DELAY_5000);
    if (compareState.showError) {
        yield put(compareActions.createToggleLimitReachedAction(false));
    }
}
export function* updateCompareProducts(optionalCompareData) {
    let compareData;
    if (optionalCompareData) {
        compareData = optionalCompareData;
    }
    else {
        const compareState = yield select(getCompareState);
        compareData = compareState.items;
    }
    yield put(compareActions.createUpdateProductsAction(compareData.map((compareProduct) => ({
        colorId: compareProduct.color,
        productCode: compareProduct.productCode,
    }))));
}
export function* loadCompareDataFromLocalStorage() {
    const { feature_toggles } = yield getContext('aemConfiguration');
    if (feature_toggles.product_compare) {
        try {
            let compareData = yield call(LocalStorageUtil.getItemWithExpiry, PRODUCT_COMPARE_LIST);
            if (isNullOrUndefined(compareData) || isNullOrUndefined(compareData[0])) {
                compareData = [];
            }
            const compareInitAction = compareActions.createInitAction(compareData);
            yield put(compareInitAction);
            yield fork(updateCompareProducts, compareData);
        }
        catch (_a) { }
    }
}
export function* updateCompare(action) {
    try {
        const compareState = yield select(getCompareState);
        const existingCompareItem = compareState.items.find((item) => item.color === action.payload.product.color && item.productCode === action.payload.product.productCode);
        if (existingCompareItem) {
            const compareRemoveAction = compareActions.createRemoveAction(action.payload);
            yield put(compareRemoveAction);
        }
        else if (compareState.items.length < MAX_COMPARE_PRODUCTS) {
            const compareAddAction = compareActions.createAddAction(action.payload);
            yield put(compareAddAction);
        }
        if (existingCompareItem || compareState.items.length < MAX_COMPARE_PRODUCTS) {
            const newCompareState = yield select(getCompareState);
            LocalStorageUtil.setItemWithExpiry(PRODUCT_COMPARE_LIST, newCompareState.items, COMPARE_STATE_LIFETIME);
            yield fork(updateCompareProducts, newCompareState.items);
            if (!action.payload.product.collapsedComparePopup) {
                yield fork(showAndHideComparePopup);
            }
            if (action.payload.product.collapsedComparePopup && !compareState.collapsed) {
                if (compareState.items.length > 1) {
                    yield delay(DELAY.DELAY_3000);
                }
                yield put(compareActions.createPopupCloseAction());
            }
        }
        else {
            yield put(compareActions.createPopupOpenAction());
            yield spawn(showCompareLimitReachedError);
        }
    }
    catch (_a) { }
}
export default function* compareSaga() {
    yield all([loadCompareDataFromLocalStorageSaga(), updateCompareSaga()]);
}
